import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faH3 } from '@fortawesome/pro-light-svg-icons';

export type ProLightH3Props = IconComponentProps;

export const ProLightH3 = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightH3Props) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faH3}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faH3}
    />
  );
};

ProLightH3.displayName = 'ProLightH3';
